import dogPurchaseAPI from '@/app/apis/main/dog-purchase/dog-purchase-api.js';

export default {
    /**
     * @return {object} list of Dog Purchase Orders
     * @params queryParams
     * */
    async getDogPurchaseList(queryParams) {
        return dogPurchaseAPI.getDogPurchaseList(queryParams);
    },

    /**
     * @return No Content
     * @param {Number} dogPurchaseId
     * @param {Object} body { status }
     * */
    async updateDogPurchaseStatus(dogPurchaseId, body) {
        return dogPurchaseAPI.updateDogPurchaseStatus(dogPurchaseId, body);
    },

    async getDogPurchasePendingRequestCount() {
        return dogPurchaseAPI.getDogPurchasePendingRequestCount();
    },
};
